import React from "react";
import { Container, Overline, Reveal } from "@/components/primitives";
import FaqSection from "@/components/FaqSection";
import { ProductFinalCTA } from "@/components/ProductSections";
import {
  sitewideFaqs,
  caseminderFaqs,
  complianceminderFaqs,
  electraFaqs,
} from "@/content/faqs";
import { useDocumentMeta, JsonLd, SITE_ORIGIN } from "@/lib/meta";

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "@id": `${SITE_ORIGIN}/faq#faq`,
  url: `${SITE_ORIGIN}/faq`,
  mainEntity: [...sitewideFaqs, ...caseminderFaqs, ...complianceminderFaqs, ...electraFaqs].map(
    (f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    }),
  ),
};

export default function FAQ() {
  useDocumentMeta({
    title: "FAQ",
    description:
      "Straight answers for owner-managed firms — about Beyond the Box, CaseMinder, ComplianceMinder and Electra HR.",
    path: "/faq",
  });
  return (
    <div data-testid="faq-page">
      <JsonLd data={faqJsonLd} />
      <section className="border-b border-border">
        <Container className="py-20 md:py-28">
          <Reveal>
            <Overline accent>FAQ · Straight answers</Overline>
            <h1 className="mt-5 max-w-3xl font-display text-5xl font-semibold leading-[1.0] tracking-tight md:text-7xl">
              No theatre. Just answers.
            </h1>
            <p className="mt-7 max-w-2xl text-lg leading-relaxed text-muted-foreground">
              The questions owner-managed firms actually ask before taking back control of
              operations, compliance, people and growth.
            </p>
          </Reveal>
        </Container>
      </section>

      <FaqSection eyebrow="Site-wide" title="About Beyond the Box" items={sitewideFaqs} testid="faq-sitewide" />
      <FaqSection eyebrow="CaseMinder" title="Operations & workflow" items={caseminderFaqs} testid="faq-caseminder" bg />
      <FaqSection
        eyebrow="ComplianceMinder"
        title="Compliance, policy & risk"
        items={complianceminderFaqs}
        testid="faq-complianceminder"
      />
      <FaqSection eyebrow="Electra HR" title="People support" items={electraFaqs} testid="faq-electra" bg />

      <ProductFinalCTA
        testid="faq-final-cta"
        title="Still deciding? Put it to the test."
        body="Book a blunt, practical walkthrough against your own firm — not a generic demo."
        label="Book a walkthrough"
      />
    </div>
  );
}
